import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { store, persistor } from "store/";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import * as serviceWorker from "./serviceWorker";

// import { createTheme, ThemeProvider } from "@material-ui/core/styles";
// import { ptBR } from "@material-ui/core/locale";

// const theme = createTheme(ptBR);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <React.StrictMode>
        {/* <ThemeProvider theme={theme}> */}
          <App />
        {/* </ThemeProvider> */}
      </React.StrictMode>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
